import api from './axios';

export async function fetchReferralDashboard(params = {}) {
  const { data } = await api.get('/admin/referrals/dashboard', { params });
  return data;
}

export async function fetchReferralAgents(params = {}) {
  const { data } = await api.get('/admin/referrals/agents', { params });
  return data;
}

export async function convertReferralPoints() {
  const { data } = await api.post('/admin/referrals/rewards/convert');
  return data;
}
